/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, replacePXinStringWithEM, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// ERROR TEMPLATE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	errortemplate: {
		padding: replacePXinStringWithEM(`100px ${theme.spacing.sides}`),
		'& #content': {
			display: 'flex',
			flexWrap: 'wrap',
			alignItems: 'center',
			alignContent: 'center',
			justifyContent: 'space-between',

			// ------ message ------ //
			'& .group.name-message': {
				width: pxToEm(485),
				marginBottom: pxToEm(40),
				// logo
				'& .logo': {
					width: pxToEm(222),
					height: pxToEm(20)
				},
				// code
				'& .code': {
					color: theme.color.primary.medium.swatch,
					fontSize: pxToEm(106),
					lineHeight: '1',
					margin: `${pxToRem(40)} 0 ${pxToRem(25)}`
				},
				// title
				'& .title': {
					
				},
				// bodycopy
				'& .bodycopy': {
					color: 'rgba(6, 43, 117, .5)',
				}
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: { 
		errortemplate: {
			'& #content': {
				justifyContent: 'center',
				'& .group.name-message': {
					textAlign: 'center'
				}
			}
		}
	},
});